/* @flow */

export const OUT_OF_PAGE_AD_TYPES = {
  TOP_ANCHOR: 'TOP_ANCHOR',
  BOTTOM_ANCHOR: 'BOTTOM_ANCHOR',
  LEFT_SIDE_RAIL: 'LEFT_SIDE_RAIL',
  RIGHT_SIDE_RAIL: 'RIGHT_SIDE_RAIL'
};

export const ANCHOR_OUT_OF_PAGE_AD_TYPES: Array<string> = [
  OUT_OF_PAGE_AD_TYPES.TOP_ANCHOR,
  OUT_OF_PAGE_AD_TYPES.BOTTOM_ANCHOR
];
